<template>
  <div class="text-right">
    <div class="hound">
      <img
        class="returns"
        @click="returnBtn"
        src="../../assets/guild/return.png"
        alt=""
      />
      <p>{{ $t("withdrawalLogin.title") }}</p>
    </div>

    <div class="head">
      <img :src="listData.icon" alt="" />
      <div class="txt">
        <div class="name">
          {{ listData.nickname }}
        </div>
        <div class="id">
          <span>ID</span> <span class="ids">{{ listData.userId }}</span>
        </div>
      </div>
    </div>

    <div class="pocket">
      <div class="pocket-txt">{{ $t("withdrawalLogin.pocket") }}</div>
      <div class="species">
        <img
          src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
          alt=""
        />
        <div>{{ listData.cin }}</div>
      </div>
    </div>

    <div class="list" v-for="item in listData.item" :key="item.id">
      <div v-if="item.name.toLowerCase() == 'papara' || item.name.toLowerCase() == 'binance' || item.id == 4">
        <div class="list-txt" style="margin-top: 0.4rem;">{{ item.name }}</div>
        <div style="display:flex;flex-wrap: wrap;">
          <div
            class="list-box"
            v-for="Aitem in item.list"
            :key="Aitem.id"
            @click="channelBtn(item, Aitem)"
          >
            <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
            <div class="money-box">
              <img
                class="money-img"
                src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                alt=""
              />
              <div class="money-num">{{ Aitem.usd }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="item.id == 10 || item.id == 9">
        <div class="list-txt" style="margin-top: 0.4rem;">{{ item.name }}</div>
        <div style="display:flex;flex-wrap: wrap;">
          <div
              class="list-box"
              v-for="Aitem in item.list"
              :key="Aitem.id"
              @click="channelPixBtn(item, Aitem)"
          >
            <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
            <div class="money-box">
              <img
                  class="money-img"
                  src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                  alt=""
              />
              <div class="money-num">{{ Aitem.usd }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model:show="show"
      closeable
      round
      position="bottom"
      :style="{ height: '20%' }"
      class="popup"
      >{{ $t("withdrawalLogin.Pocket") }}</van-popup
    >
    <div v-if="officialUrl" class="officialBox">
      <p>{{ $t("withdrawalLogin.officialGroup") }}</p>
      <p>
        <a :href="officialUrl">{{ officialUrl }}</a>
      </p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  name: "App",
  components: {},
  data() {
    return {
      listData: {},
      token: "",
      uid: "",
      lang: "",
      show: false,
      deviceId: '',
      officialUrl:'',
    };
  },
  created() {
    var ids = navigator.userAgent.match(
      /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
    );
    if (ids) {
      ids = ids[0];
    } else {
      ids = "Unknown Device";
    }
    let data = JSON.parse(localStorage.getItem("data"));
    this.token = data.token;
    this.uid = data.uid || data.userId;
    this.lang = data.lang || navigator.language;
    this.deviceId = data.deviceId || ids
    this.contact();
    this.getWhatsapp()
    if(data.uid){
    this.changeTime()
    }
    
  },
  mounted() {
    let langs = this.lang.substring(0, 2);
    if (langs == "zh") {
      if (this.lang == "zh-TW" || this.lang == "zh-HK") {
        this.$i18n.locale = "tc";
      } else {
        this.$i18n.locale = "zh";
      }
    } else if (langs == "en") {
      this.$i18n.locale = "en";
    } else if (langs == "ar") {
      this.$i18n.locale = "ar";
    } else if (langs == "tr") {
      this.$i18n.locale = "tr";
    } else if (langs == "es") {
      this.$i18n.locale = "es";
    } else if (langs == "pt") {
      this.$i18n.locale = "pt";
    } else {
      this.$i18n.locale = "en";
    }

    document.title = this.$t("withdrawalLogin.title");
    document.querySelector("html").setAttribute("lang", this.$i18n.locale);

    
  },

  methods: {
    returnBtn() {
      if(this.$route.query.type == 1){
      this.$completes.complete("getPreviousPage");
      }else{
      this.$router.push("/withdrawalLogin");
      }
    },

    contact() {
      axios
        .get(this.$serviceIp +`/api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.listData = response.data.data;
            this.sortList(this.listData.item);
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },
    // 获取官方群
    getWhatsapp() {
      axios
        .get(this.$serviceIp +`/api/trade/withdraw/whatsappForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'version': '3.0',
                'deviceId': this.deviceId
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
              this.officialUrl = response.data.data;
          }
        });
    },
    // 排序
    sortList(item){
      item.forEach(element => {
        element.list.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
    channelBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/withdrawalDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
                id:item.id
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    channelPixBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/pixDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    changeTime() {
      let item = JSON.parse(localStorage.getItem("time"));
      if (item < Date.now()) {
        localStorage.removeItem("data");
        localStorage.removeItem("time");
        this.$router.push("/withdrawalLogin");
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

html[lang="ar"] .hound {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .head {
  direction: rtl;
}

html[lang="ar"] .pocket {
  direction: rtl;
}
html[lang="ar"] .list {
  direction: rtl;
}
html[lang="ar"] .txt {
  margin-right: 0.3rem;
}
html[lang="ar"] .species img {
  margin-left: 0.1rem;
}
.hound {
  width: 100%;
  height: 0.75rem;
  display: flex;
  align-items: center;
  padding-top: 44px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  position:relative;
}

.returns {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
}

.hound p {
  flex: 1;
  font-size: 0.31rem;
  text-align: center;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.head {
  height: 0.95rem;
  width: 5.9rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
}

.head img {
  width: 0.96rem;
  height: 0.96rem;
  border-radius: 50%;
}
.txt {
  width: 2rem;
  height: 0.7rem;
  margin-left: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.name {
  font-size: 0.27rem;
  font-family: Rubik;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.id {
  font-size: 0.24rem;
  font-family: Rubik;
  font-weight: 400;
  color: #acadbc;
}
.pocket {
  width: 5.9rem;
  height: 1rem;
  background: linear-gradient(180deg, #ffffff -6.39%, #fff2d0 100%);
  border-radius: 12px;
  margin-top: 0.34rem;
  padding: 0 0.34rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.pocket-txt {
  /* width: 1.5rem; */
  height: 0.34rem;
  font-size: 0.24rem;
  color: rgba(0, 0, 0, 0.5);
  font-family: PingFang SC;
}
.species {
  /* width: 1.24rem; */
  height: 0.44rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.species img {
  width: 0.41rem;
  height: 0.41rem;
  margin-right: 0.1rem;
}

.species div {
  /* width: 0.73rem; */
  height: 0.45rem;
  font-size: 0.37rem;
  color: rgba(128, 62, 57, 1);
  font-family: Rubik;
}

.list {
  width: 5.8rem;
  /* height: 1.9rem; */
  /* margin-top: 0.4rem; */
}

.list-box {
  width: 1.77rem;
  height: 1.5rem;
  margin-top: 0.3rem;
  margin-left: 0.1rem;
  border-radius: 10px;
  border: 1px solid rgba(0, 210, 147, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.list-txt {
  height: 0.32rem;
  font-size: 0.27rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 1);
}

.money {
  /* width: 0.43rem; */
  height: 0.43rem;
  font-size: 0.37rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
}

.money-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.money-img {
  width: 0.27rem;
  height: 0.27rem;
}

.money-num {
  /* width: 0.6rem; */
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: rgba(128, 62, 57, 1);
  font-weight: 500;
  font-family: Rubik;
}
.popup {
  font-size: 0.24rem;
  color: #000000;
  font-weight: 500;
  font-family: Rubik;
  display: flex;
  justify-content: center;
  align-items: center;
}
.officialBox{
  margin-top: 20px;
  width: 590px;
}
.officialBox p{
  font-size: 32px;
}
</style>
